import { createFileRoute } from "@tanstack/react-router";
import Page, { faqItems } from "@/pages/ConsultaNutricionalOnline";
import { pageHead, faqJsonLd, breadcrumbJsonLd } from "@/lib/seo";

export const Route = createFileRoute("/consulta-nutricional-online-australia")({
  head: () =>
    pageHead({
      title: "Consulta nutricional online na Austrália | Clara Camille",
      description:
        "Consulta nutricional online em português na Austrália. Plano alimentar personalizado por videochamada. Primeira consulta gratuita.",
      path: "/consulta-nutricional-online-australia",
      ogDescription:
        "Atendimento por videochamada em português com plano alimentar personalizado para brasileiros. Primeira consulta gratuita.",
      jsonLd: [
        breadcrumbJsonLd([{ name: "Consulta nutricional online", path: "/consulta-nutricional-online-australia" }]),
        faqJsonLd(faqItems),
      ],
    }),
  component: Page,
});
